import catInAFlatRegularWoff from '@rover/shared/fonts/Cat-in-a-Flat-Regular.woff';
import catInAFlatRegularWoff2 from '@rover/shared/fonts/Cat-in-a-Flat-Regular.woff2';

export default `
@font-face {
  font-family: 'Cat-in-a-Flat-Regular';
  src: url(${catInAFlatRegularWoff2}) format('woff2'),
    url(${catInAFlatRegularWoff}) format('woff');
  font-display: swap;
}`;
